import { EnvService } from "../service/env.service";

export const EnvServiceFactory = () => {
  
  const ENABLE_CONSOLE_LOGS = "ENABLE_CONSOLE_LOGS";
  // Create env
  const env = new EnvService();

  // Read environment variables from browser window
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['__env'] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[key] = window['__env'][key];

      if (key === ENABLE_CONSOLE_LOGS) {
        enableConsoleLogs(window['__env'][key]);
      }
    }
  }

  return env;
};

function enableConsoleLogs(enable: boolean) {
  if (window && !enable) {
    // disable console logs
    window.console.log = function() {};
  }
}

export const EnvServiceProvider = {  
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};